import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cancel-request-modal',
  templateUrl: './cancel-request-modal.component.html',
  styleUrls: ['./cancel-request-modal.component.scss']
})
export class CancelRequestModalComponent implements OnInit {

  @Input() requestId: number;
  public event: EventEmitter<{requestId: number, cancellationReason: string}> = new EventEmitter();
  cancellationForm: FormGroup;

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.cancellationForm = this.formBuilder.group({
      cancellationReason: ['', [Validators.required]],
    });
  }

  handleModalHide() {
    this.bsModalRef.hide();
  }

  onContinueEvent(){
    this.event.emit({requestId: this.requestId, ...this.cancellationForm.value});
  }

  checkSubmitDisable(){
    return this.cancellationForm.invalid;
  }
}
